import {classify, PLAYS} from './analysis';

export const DRAGON_TYPES = [
  {id:'repeat', label:'连续', period:1, minimum:3},
  {id:'alternate', label:'交替', period:2, minimum:4},
  {id:'abb', label:'ABB循环', period:3, minimum:6},
];

// Only patterns ending at the latest draw are ongoing. History is newest first.
export function currentDragons(history, kind) {
  return PLAYS[kind].flatMap(([play,label]) => {
    const values=[];
    for (let i=0;i<history.length;i++) {
      if (i && Number(history[i-1].issue)-Number(history[i].issue)!==1) break;
      const value=classify(history[i],kind,play);
      if (!value || value==='和') break;
      values.push(value);
    }
    return DRAGON_TYPES.flatMap(type => {
      const {period,minimum}=type;
      if (values.length<minimum) return [];
      const pattern=values.slice(0,period);
      if (period>1 && new Set(pattern).size!==2) return [];
      let count=period;
      while (count<values.length && values[count]===pattern[count%period]) count++;
      if (count<minimum) return [];
      return [{id:`${play}:${type.id}`, play, label, type:type.label, count,
        sequence:values.slice(0,count).reverse(), start:history[count-1].issue,
        end:history[0].issue, atLeast:count===history.length}];
    });
  });
}
